import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography, Button } from '@mui/material';
import MissingContent from '../../../../components/shared/errorMessages/MissingContent';

interface CMSConsumerInternationalsProps {
  internationalsSingle: string | null;
  internationalsLink: string;
  internationalsDescription: string | null;
  marginTop?: number;
  marginBottom?: number;
}

const CMSConsumerInternationalsSection: React.FC<CMSConsumerInternationalsProps> = ({
                                                                                      internationalsSingle,
                                                                                      internationalsLink,
                                                                                      internationalsDescription,
                                                                                      marginTop = 15,
                                                                                      marginBottom = 15
                                                                                    }) => {
  const navigate = useNavigate();

  // Show missing content if no image data
  if (!internationalsSingle || !internationalsLink) {
    return <MissingContent sectionName="Internationals Section" />;
  }

  const handleExploreClick = () => {
    navigate('internationals');
  };

  return (
    <Grid
      mt={{ xs: '0', lg: marginTop }}
      mb={marginBottom}
      container
      sx={{ width: '100%', height: { xs: 'auto', lg: 'auto' } }}
    >
      {/* Image Section */}
      <Box
        sx={{
          display: { xs: 'flex' },
          flexDirection: { xs: 'column', lg: 'row' },
          width: { xs: '100%', lg: '50%' },
        }}
      >
        <img
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          src={internationalsLink}
          alt="Hertex Internationals"
        />
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          width: { xs: '100%', lg: '50%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#FFF',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: { xs: '90%', lg: '80%' },
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: { xs: 'flex-start', lg: 'center' },
            p: { xs: '0 0rem', sm: '0' },
          }}
        >
          <Box>
            {/* Title */}
            <Typography
              mt={2}
              variant="h3"
              fontWeight={'500'}
              sx={{
                lineHeight: '72px',
                fontSize: '56px',
              }}
            >
              Hertex Internationals
            </Typography>

            {/* Description */}
            <Typography
              mt={{ xs: 0, lg: 2 }}
              sx={{
                color: '#000',
                fontWeight: '300',
                lineHeight: '28px',
                fontSize: '16px',
              }}
            >
              {internationalsDescription || 'We are the exclusive distributor of some of the world\'s most sought-after fabric and wallcovering brands. Sourced from premier design houses in Europe, the UK, and the USA, these luxurious collections are available exclusively through Hertex.'}
            </Typography>

            {/* Explore Button */}
            <Button
              sx={{
                mt: '3rem',
                width: { xs: '100%', lg: '200px' },
              }}
              fullWidth
              variant="outlined"
              onClick={handleExploreClick}
            >
              Explore More
            </Button>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default CMSConsumerInternationalsSection;